import { get } from "api/axios-client";
import { StandardJobSearchResult } from "components/QueueBoard/models/workOrderTypes";

const controllerUrl = "api/StandardJobStep/";
export interface Slide {
  src: string;
}
export const SegmentApi = {
  SearchStandardJobStep: async (
    source: string,
    jobType: string,
    searchString: string,
  ): Promise<StandardJobSearchResult[]> => {
    try {
      const { data } = await get(
        `${controllerUrl}SearchStandardJobStep?source=${source}&jobType=${jobType}&searchString=${searchString}`,
      );
      return data;
    } catch (err) {
      //console.log(err);
      return null;
    }
  },
};
